import { useEffect, useState } from "react";
import { supabase } from "./supabase";

// Returns live count of: unread chat messages + pending action items from broker.
// Subscribes to realtime so the badge updates without refresh.
export function useUnreadCount(clientId) {
  const [count, setCount] = useState(0);

  const refetch = async () => {
    if (!supabase || !clientId) { setCount(0); return; }
    const [{ count: chats }, { count: actions }] = await Promise.all([
      supabase
        .from("messages")
        .select("id", { count: "exact", head: true })
        .eq("client_id", clientId)
        .eq("from_role", "broker")
        .eq("message_type", "chat")
        .is("read_at", null),
      supabase
        .from("messages")
        .select("id", { count: "exact", head: true })
        .eq("client_id", clientId)
        .eq("from_role", "broker")
        .eq("message_type", "action")
        .is("completed_at", null),
    ]);
    setCount((chats || 0) + (actions || 0));
  };

  useEffect(() => {
    if (!supabase || !clientId) return;
    refetch();
    const channel = supabase
      .channel(`unread:${clientId}`)
      .on("postgres_changes", {
        event: "*", schema: "public", table: "messages",
        filter: `client_id=eq.${clientId}`,
      }, refetch)
      .subscribe();
    return () => supabase.removeChannel(channel);
  }, [clientId]); // eslint-disable-line

  return count;
}
